import { AxiosError } from 'axios';
import axios from 'axios';
import { notificationHelper } from 'helpers';
import { userServices } from 'services';
import { isEnvelopeRoute } from './apiEnvelope';

const STATUS_SUCCESS = 'success';

class LogicError extends Error {
  constructor(
    public code: string | undefined,
    message: string,
    public extra: any,
  ) {
    super(code);
  }
}

const normalizeParams = (params: any) =>
  Object.entries(params).reduce((accum, param) => {
    const [key, value] = param;
    if (value && value !== 'all') {
      const obj: any = { ...accum };
      obj[key] = value;
      return obj;
    }
    return accum;
  }, {});

const handleRequestError = (error: AxiosError | any) => {
  // Skip showing notifications for canceled requests
  if (axios.isCancel && axios.isCancel(error)) {
    return;
  }
  
  // Skip showing notifications for errors from suggestions API
  const requestUrl = error?.config?.url || error?.response?.config?.url || error?.request?.responseURL || '';
  // Check for suggestions endpoint (handles both full URLs and relative paths)
  if (requestUrl && requestUrl.includes('/suggestions')) {
    return;
  }

  const status = error && error.response && error.response.status;

  // Alert/channel screens show these errors inline; only 401 stays global.
  if (status !== 401 && isEnvelopeRoute(requestUrl)) {
    return;
  }
  switch (status) {
    case 401:
      if (error.response?.config.url === '/login') {
        notificationHelper.error(
          'Đăng nhập thất bại',
          error.response.data.message,
        );
        return;
      }

      userServices.logout();

      break;
    case 403:
      userServices.denyAccess();
      break;
    default: {
      if (error.response && error.response.data && error.response.data.error) {
        const title = String(error.response.status);

        notificationHelper.error(title, error.response.data.message);
      } else {
        notificationHelper.error(
          'Network request failed',
          `Network status ${status}`,
        );
      }
    }
  }
};

const handleRequestSuccess = (data: any) => {
  if (data.code && data.code !== STATUS_SUCCESS) {
    const title = data.code;
    const { message } = data;
    notificationHelper.error(title, message);
    throw new LogicError(data.code, message, data.extra);
  }
};
export default {
  normalizeParams,
  handleRequestError,
  handleRequestSuccess,
};
